import "./Header.css"
const Header = () => {
  return <header>
    <img src="https://cdn.pixabay.com/photo/2017/05/25/14/58/book-2343533_1280.png" alt="" />
    <p>Michel Foucault</p>
  </header>;
};
export default Header;
